firebird.factory('meetingNotesService', [
    '$rootScope',
    '$state',
    '$timeout',
    '$window',
    'analyticsWrapperService',
    'attendeeService',
    'inputService',
    'logService',
    'meetingService',
    'socketService',
    'helperService',
    'notificationService',
    function (
        $rootScope,
        $state,
        $timeout,
        $window,
        analyticsWrapperService,
        attendeeService,
        inputService,
        logService,
        meetingService,
        socketService,
        helperService,
        notificationService
    ) {
        const logger = logService.createLoggerWithSource('meetingNotesService');

        var service = {
            hasMeetingNotes: hasMeetingNotes,
            canUseMeetingNotes: canUseMeetingNotes,
            init: init,
            rearrangeToolbar: rearrangeToolbar,
            getNonePersistenceType: getNonePersistenceType,
            addCopyTextButton: addCopyTextButton,
            onCopyNotesToClipboard: onCopyNotesToClipboard,
            reformatFirepadCheckboxes: reformatFirepadCheckboxes,
            pasteToFirepadAsRegularText: pasteToFirepadAsRegularText,
            replaceCopyPasteShortcut: replaceCopyPasteShortcut
        };

        var _initialized = false;

        var _firebaseToken = '';
        var _firebaseConfig = '';
        let tryCount = 1;
        let maxTryCount = 3;
        let richTextClipboard = {
            plainText: '',
            richText: ''
        };

        var _codeMirror;
        var _firepad = null; // Firepad instance
        var _urlTextMarkers = [];

        $rootScope.$on('firebase-info', _onFirebaseInfo);
        $rootScope.$on('meeting-ending', _onMeetingEnding);
        $rootScope.$on('$stateChangeSuccess', _stateChangeSuccess);
        $rootScope.$on('append-to-notes', _onAppendToMeetingNotes);

        return service;

        ////////////////////////

        function _createFirebase() {
            let config = _firebaseConfig;
            let dbRef = 'public-notes/' + meetingService.getMeetingCode();
            let oldMessageFiltered = false;
            let meetingNoteInputEventAlreadyTracked = false;
            let attendantId = attendeeService.getAttendantId().toString();

            $window.firebase.initializeApp(config);
            $window.firebase
                .database()
                .ref(dbRef)
                .child('history')
                .on('child_added', function (message) {
                    if (!oldMessageFiltered) {
                        return;
                    }

                    var msg = message.val();
                    if (msg.a === attendantId && meetingNoteInputEventAlreadyTracked === false) {
                        meetingNoteInputEventAlreadyTracked = true;
                        analyticsWrapperService.eventTrack('meeting - meeting note - first time user input', {
                            category: 'meeting note'
                        });
                    }
                });

            // we are doing the once to filter out old messages because firebase loads
            // everything the first time an event listener is set up for firebase
            $window.firebase
                .database()
                .ref(dbRef)
                .child('history')
                .once('value', function (messages) {
                    oldMessageFiltered = true;
                    var message;

                    messages.forEach(function (msg) {
                        message = msg.val();
                        if (message.a === attendantId) {
                            // this implies this user had already made some changes to meeting note
                            // not a first time input
                            meetingNoteInputEventAlreadyTracked = true;
                            return true;
                        }
                    });
                });

            initializeFirePad();
        }

        function initializeFirePad() {
            let token = _firebaseToken;
            let dbRef = 'public-notes/' + meetingService.getMeetingCode();
            let attendantId = attendeeService.getAttendantId().toString();

            // Set persistence to NONE because each new browser tab or Unite window will execute this code and set new token.
            // Other tabs (Unite windows) will then have permission_denied errors when trying to update meeting notes (ANYAM-94130).
            $window.firebase
                .auth()
                .setPersistence(service.getNonePersistenceType())
                .then(() => {
                    $window.firebase
                        .auth()
                        .signInWithCustomToken(token)
                        .then(function (cred) {
                            logger.log('initializeFirePad', 'firebase authenticated', cred?.user?.uid);
                            // On Firefox, this is not available (i.e., firepadDiv.length === 0) if assigned in the initialization block
                            // of the createFirebase function, so it is moved here.
                            var firepadDiv = angular.element($window.document.querySelector('#note-firepad'));
                            _codeMirror = $window.CodeMirror(firepadDiv[0], { lineWrapping: true });
                            _codeMirror.on('changes', function (instance, changes) {
                                $rootScope.$broadcast('meeting-notes-message');
                                refreshUrlTextMarkers();
                            });
                            $rootScope.$on('angular-resizable.resizing', function () {
                                _codeMirror.refresh();
                            });
                            var options = { richTextShortcuts: true, richTextToolbar: true, imageInsertionUI: false };

                            var firepad = $window.Firepad.fromCodeMirror(
                                $window.firebase.database().ref(dbRef),
                                _codeMirror,
                                options
                            );
                            _firepad = firepad;
                            firepad.on('ready', function () {
                                logger.log('meetingNotesService: firepad ready');
                                firepad.setUserId(attendantId);

                                setCustomStyle();

                                if (helperService.getIsRedesign()) {
                                    service.rearrangeToolbar();
                                }
                                service.addCopyTextButton();
                                service.replaceCopyPasteShortcut();
                                refreshUrlTextMarkers();
                            });

                            inputService.setNotesElement(_codeMirror);
                        })
                        .catch(function (error) {
                            logger.error('initializeFirePad', 'signInWithCustomToken error', error);

                            if (tryCount <= maxTryCount) {
                                console.log('meetingNotesService: signInWithCustomToken retry attempt', tryCount);
                                setTimeout(() => {
                                    initializeFirePad(token);
                                }, 1000 * tryCount);
                                tryCount++;
                            }

                            return;
                        });
                })
                .catch(error => {
                    logger.error('initializeFirePad', 'setPersistence error', error);
                });
        }

        function getNonePersistenceType() {
            return $window.firebase.auth.Auth.Persistence.NONE;
        }

        function rearrangeToolbar() {
            var toolbar = '#note-firepad .firepad-toolbar-wrapper';
            var elementsToMove = ['.firepad-tb-list-2', '.firepad-tb-paragraph-center', '.firepad-tb-indent-decrease'];

            $window.$(toolbar).append('<br/>');

            elementsToMove.forEach(function (element) {
                //Moves these elements to the end of the toolbar
                $window.$(element).closest('.firepad-btn-group').addClass('shaded').appendTo(toolbar);
            });
        }

        function setCustomStyle() {
            var colorItem = $window.$('#note-firepad a.firepad-btn.firepad-dropdown:contains(Color)');
            var sizeItem = $window.$('#note-firepad a.firepad-btn.firepad-dropdown:contains(Size)');

            if (colorItem) {
                colorItem
                    .contents()
                    .filter(function () {
                        return this.nodeType === 3;
                    })
                    .remove();
                colorItem.prepend("<div class='firepad-color-image'></div>\u25be");
            }
            if (sizeItem) {
                sizeItem
                    .contents()
                    .filter(function () {
                        return this.nodeType === 3;
                    })
                    .remove();
                sizeItem.prepend("<span class='firepad-size-image'>\u25be</span>");
            }
        }

        function hasMeetingNotes() {
            if (meetingService.isWebinar()) {
                return false;
            } else {
                // TODO: Update API so that we only need to rely on hasFeature('notes')
                return meetingService.hasFeature('notes') && meetingService.hasFeature('recording');
            }
        }

        function canUseMeetingNotes() {
            return meetingService.canUseMeetingNotes();
        }

        function init() {
            if (_initialized === true) {
                return;
            } else {
                initialized = true;
            }

            if (service.hasMeetingNotes()) {
                _requestFirebaseInfo();
            }
        }

        function _onFirebaseInfo(evt, data) {
            logger.log('_onFirebaseInfo', 'firebase-info received');
            _firebaseToken = data.newToken;
            _firebaseConfig = data.config;
            _createFirebase();
        }

        function _requestFirebaseInfo() {
            socketService.send({ message: 'firebase-info', data: {} });
        }

        function _stateChangeSuccess(event, toState, toParams, fromState, fromParams) {
            if ($state.includes('meeting-active.firepad')) {
                $timeout(function () {
                    _codeMirror.refresh();
                });
            }
        }

        function _onAppendToMeetingNotes(evt, data) {
            logger.log('meetingNotesService: append-to-notes: ', data);

            if (_firepad && data && data.text) {
                var existing = _firepad.getText();
                _firepad.setText((existing ? existing + '\n' : '') + data.text);
            }
        }

        function _onMeetingEnding() {
            try {
                logger.log('_onMeetingEnding', 'dispose meeting notes objects');

                if (_firepad && typeof _firepad.dispose === 'function') {
                    _firepad.dispose();
                }

                clearUrlTextMarkers();

                if ($window.firebase) {
                    $window.firebase.app().delete();
                }
            } catch (error) {
                logger.error('_onMeetingEnding', 'failed to dispose meeting notes objects', error);
            }
        }

        function addCopyTextButton() {
            if ($window.document.getElementsByClassName('firepad-copy-text-btn')[0]) {
                return;
            }
            const copyTextPosition = $window.document.getElementsByClassName('firepad-btn-group')[4];

            const copyTextIconElement = $window.document.createElement('img');
            copyTextIconElement.src = '/img/redesign/icons/copy-to-clipboard.svg';

            const copyTextButtonElement = $window.document.createElement('a');
            copyTextButtonElement.classList.add('firepad-btn', 'firepad-copy-text-btn');
            copyTextButtonElement.onclick = function () {
                onCopyNotesToClipboard();
            };
            copyTextButtonElement.appendChild(copyTextIconElement);

            const copyTextContainer = $window.document.createElement('div');
            copyTextContainer.classList.add('firepad-btn-group');
            copyTextContainer.appendChild(copyTextButtonElement);

            copyTextPosition.after(copyTextContainer);
        }

        function onCopyNotesToClipboard() {
            var text = _firepad.getText();
            var html = reformatFirepadCheckboxes(_firepad.getHtml());

            const options = {
                successCallback: function () {
                    notificationService.show('Copied to clipboard', 'success');
                },
                errorCallback: function () {
                    notificationService.show('Failed to copy', 'danger');
                }
            };

            $rootScope.$broadcast('copy-text-to-clipboard', { text: text, html: html, options: options });
        }

        function reformatFirepadCheckboxes(html) {
            return html
                .replaceAll(/<li class="firepad-checked"[^>]*>/gi, '<li><input type="checkbox" checked/>&nbsp;')
                .replaceAll(/<li class="firepad-unchecked"[^>]*>/gi, '<li><input type="checkbox"/>&nbsp;');
        }

        function replaceCopyPasteShortcut() {
            let EventTarget = $window.$('.CodeMirror')[0];

            EventTarget.addEventListener('keydown', evt => {
                if (helperService.isMac() && evt.key === 'v') {
                    if (evt.metaKey) {
                        evt.preventDefault();
                        evt.stopPropagation();
                    }
                } else {
                    if (evt.ctrlKey && evt.key === 'v') {
                        evt.preventDefault();
                        evt.stopPropagation();
                    }
                }

                if (
                    (helperService.isMac() && evt.key === 'c' && evt.metaKey) ||
                    (!helperService.isMac() && evt.key === 'c' && evt.ctrlKey)
                ) {
                    $window.navigator.clipboard
                        .readText()
                        .then(text => {
                            richTextClipboard = {
                                plainText: text,
                                richText: _firepad.getHtmlFromSelection()
                            };
                        })
                        .catch(err => {
                            logger.error('replaceCopyPasteShortcut', 'read from clipboard failed', err);
                        });
                } else if (
                    (helperService.isMac() && evt.key === 'v' && evt.metaKey) ||
                    (!helperService.isMac() && evt.key === 'v' && evt.ctrlKey)
                ) {
                    // We are going to try to paste html first
                    $window.navigator.clipboard
                        .read()
                        .then(items => {
                            items[0]
                                .getType('text/html')
                                .then(blob => {
                                    blob.text()
                                        .then(html => {
                                            var normalizedHtml = (html || '').trim();

                                            if (isUrl(normalizedHtml)) {
                                                var normalizedHtmlHref = normalizeUrl(normalizedHtml);
                                                _firepad.insertHtmlAtCursor(
                                                    '<a href="' +
                                                        escapeHtml(normalizedHtmlHref) +
                                                        '">' +
                                                        escapeHtml(normalizedHtml) +
                                                        '</a>'
                                                );
                                            } else {
                                                _firepad.insertHtmlAtCursor(html);
                                            }
                                        })
                                        .catch(err => {
                                            service.pasteToFirepadAsRegularText();
                                        });
                                })
                                .catch(err => {
                                    service.pasteToFirepadAsRegularText();
                                });
                        })
                        .catch(err => {
                            service.pasteToFirepadAsRegularText();
                        });
                }
            });

            EventTarget.addEventListener('click', evt => {
                if (!shouldHandleUrlClick(evt)) {
                    return;
                }

                var anchorTarget = evt.target && evt.target.closest ? evt.target.closest('a[href]') : null;

                if (anchorTarget && anchorTarget.href) {
                    evt.preventDefault();
                    evt.stopPropagation();
                    $window.open(anchorTarget.href, '_blank', 'noopener,noreferrer');
                    return;
                }

                if (
                    !_codeMirror ||
                    typeof _codeMirror.coordsChar !== 'function' ||
                    typeof _codeMirror.getLine !== 'function'
                ) {
                    return;
                }

                var position = _codeMirror.coordsChar({ left: evt.clientX, top: evt.clientY });

                if (!position || typeof position.line !== 'number' || typeof position.ch !== 'number') {
                    return;
                }

                var lineText = _codeMirror.getLine(position.line);

                if (!lineText) {
                    return;
                }

                var urlMatch = findUrlAtPosition(lineText, position.ch);

                if (!urlMatch) {
                    return;
                }

                evt.preventDefault();
                evt.stopPropagation();
                $window.open(normalizeUrl(urlMatch), '_blank', 'noopener,noreferrer');
            });
        }

        function shouldHandleUrlClick(evt) {
            if (!evt || evt.defaultPrevented) {
                return false;
            }

            if (evt.button !== 0 || evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey) {
                return false;
            }

            var selectedText = ($window.getSelection && $window.getSelection().toString()) || '';

            if (selectedText.trim().length > 0) {
                return false;
            }

            return true;
        }

        function pasteToFirepadAsRegularText() {
            $window.navigator.clipboard
                .readText()
                .then(text => {
                    if (richTextClipboard.plainText === text && richTextClipboard.richText.includes('<div>')) {
                        _firepad.insertHtmlAtCursor(richTextClipboard.richText);
                    } else if (isUrl(text)) {
                        var trimmedText = text.trim();
                        var normalizedUrl = normalizeUrl(trimmedText);
                        _firepad.insertHtmlAtCursor(
                            '<a href="' + escapeHtml(normalizedUrl) + '">' + escapeHtml(trimmedText) + '</a>'
                        );
                    } else {
                        _firepad.insertTextAtCursor(text);
                    }
                })
                .catch(err => {
                    logger.error('replaceCopyPasteShortcut', 'paste from clipboard failed', err);
                });
        }

        function isUrl(text) {
            if (!text || typeof text !== 'string') {
                return false;
            }

            var trimmedText = text.trim();
            var normalizedUrl = normalizeUrl(trimmedText);

            if (/\s/.test(normalizedUrl)) {
                return false;
            }

            try {
                var parsedUrl = new URL(normalizedUrl);
                return parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:';
            } catch (error) {
                return false;
            }
        }

        function normalizeUrl(text) {
            var trimmedText = (text || '').trim();

            if (/^www\./i.test(trimmedText)) {
                return 'https://' + trimmedText;
            }

            return trimmedText;
        }

        function findUrlAtPosition(text, cursorCh) {
            var urlRegex = /(https?:\/\/[^\s<>"]+|www\.[^\s<>"]+)/gi;
            var match;

            if (cursorCh < 0 || cursorCh >= text.length || /\s/.test(text.charAt(cursorCh))) {
                return null;
            }

            while ((match = urlRegex.exec(text)) !== null) {
                var start = match.index;
                var end = start + match[0].length;

                if (cursorCh >= start && cursorCh < end) {
                    return match[0];
                }
            }

            return null;
        }

        function clearUrlTextMarkers() {
            _urlTextMarkers.forEach(marker => {
                if (marker && typeof marker.clear === 'function') {
                    marker.clear();
                }
            });

            _urlTextMarkers = [];
        }

        function refreshUrlTextMarkers() {
            if (
                !_codeMirror ||
                typeof _codeMirror.lineCount !== 'function' ||
                typeof _codeMirror.markText !== 'function'
            ) {
                return;
            }

            clearUrlTextMarkers();

            var urlRegex = /(https?:\/\/[^\s<>"]+|www\.[^\s<>"]+)/gi;
            var lineCount = _codeMirror.lineCount();

            for (var lineNumber = 0; lineNumber < lineCount; lineNumber++) {
                var lineText = _codeMirror.getLine(lineNumber) || '';
                var match;

                while ((match = urlRegex.exec(lineText)) !== null) {
                    var start = match.index;
                    var end = start + match[0].length;

                    _urlTextMarkers.push(
                        _codeMirror.markText(
                            { line: lineNumber, ch: start },
                            { line: lineNumber, ch: end },
                            { css: 'text-decoration: underline; cursor: pointer;' }
                        )
                    );
                }
            }
        }

        function escapeHtml(value) {
            return value
                .replaceAll('&', '&amp;')
                .replaceAll('<', '&lt;')
                .replaceAll('>', '&gt;')
                .replaceAll('"', '&quot;');
        }
    }
]);
